import React from 'react';

const Home = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <h2 className="text-4xl font-medium text-gray-900 mb-8">Home</h2>
      <div className="bg-white p-8 rounded-lg">
        <p className="text-gray-600">Home</p>
      </div>
    </section>
  );
};

export default Home;